/**
 * Type guard for checking if a value is a string.
 */
function isString(value: unknown): value is string {
  return typeof value === "string";
}

export { isString };
